import { combineReducers } from "redux";
import contactSlice from "./contact";
import authSlice from "./auth"

export default combineReducers({
  contact: contactSlice,
  auth: authSlice
});
